<template>
 
	
    <el-menu 
      :default-active="activeMenu"
      background-color="#545c64"
      :collapse="isCollapse"
      text-color="#fff"
      active-text-color="#ffd04b" >
      <cl-side-item
        v-for="(route, index) in permission_routes"
        :key="index"
        :item="route"
      ></cl-side-item>
    
    </el-menu>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  
  data() {
    return {
      	  isCollapse: false
         };
  },
  methods: {
		    isC(){
		      this.isCollapse = !this.isCollapse
		    }
	  },
  computed: {
    ...mapGetters([
      'permission_routes'
    ]),

    activeMenu () {
      window.console.log('active menu is ' + this.$route.path)
      return this.$route.path
    }
  },
  components: {
    'cl-side-item': () => import('./side-item')
  },
  mounted: function () {
    // window.console.log(this.item.path)
  }
}
</script>
<style>
	.el-menu-vertical:not(.el-menu--collapse) {
	    width: 100;
    }
 
</style>
